"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  '@import': ['url(https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap)'],
  '@global': {
    'input[type="text"]': {
      '&.InputCode': {
        backgroundRepeat: 'repeat-x',
        height: '32px',
        border: 0,
        outline: 0,
        textAlign: 'left',
        padding: 0,
        fontFamily: ['Roboto Mono', 'monospace'],
        fontSize: '12px',
        fontWeight: 400,
        wordSpacing: 27.6,
        textIndent: 12.5
      }
    }
  }
};
exports["default"] = _default;
//# sourceMappingURL=style.js.map